import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore, selectIsAuthenticated, selectUser } from '../stores/authStore'

/**
 * Wraps public-only routes (/, /login, /register). Rules:
 * - Not authenticated → render Outlet (landing page, login, register)
 * - Authenticated + not onboarded → /onboarding
 * - Authenticated + onboarded → /home
 */
export default function PublicOnlyRoute() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  const user = useAuthStore(selectUser)

  if (!isAuthenticated) return <Outlet />
  if (user && !user.onboarding_completed) return <Navigate to="/onboarding" replace />
  return <Navigate to="/home" replace />
}
